import { getAuth } from "firebase/auth";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  setDoc,
} from "firebase/firestore";
import {
  getDownloadURL,
  getStorage,
  listAll,
  ref,
  uploadBytes,
} from "firebase/storage";
import React, { useEffect, useRef, useState } from "react";
import GetUser from "../../../controllers/auth/GetUser";
import { updateUser } from "../../../controllers/auth/updateUser";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";

let unsubscribe;
let unsub;

export default function useIncompleteSettings() {
  const [ClientData, setClientData] = useState();
  const [AuthUser, setAuthUser] = useState(false);
  const [isBusinessNameEmpty, setIsBusinessNameEmpty] = useState(true);
  const [isUserPhoneEmpty, setIsUserPhoneEmpty] = useState(true);
  const [IsUserNameEmplty, setIsUserNameEmplty] = useState(true);

  useEffect(() => {
    const fetchAndCheck = async () => {
      const user = await GetUser(getAuth().currentUser.uid);
      if (user.name) {
        setAuthUser(false);
      } else {
        setAuthUser(true);
      }
    };

    try {
    } catch (error) {
      // console.log()
    }
    getAuth().onAuthStateChanged(() => {
      fetchAndCheck();
    });
  }, [IsUserNameEmplty]);

  // Get Client Data Start
  useEffect(() => {
    async function fetchData() {
      const clientsDocument = await doc(
        db,
        "clients",
        getLocalStorageItem("bid")
      );

      const clientSnapshot = await getDoc(clientsDocument);

      const client = { ...clientSnapshot.data(), id: clientSnapshot.id };
      setClientData(client && client);
    }

    fetchData();
  }, [isBusinessNameEmpty]);
  // Get Client Data End

  //sideEffect for listening to client data
  useEffect(() => {
    const q = query(
      doc(db, "clients", getLocalStorageItem("bid"))
      // ,
      // limit(leadsLimit)
    );
    unsubscribe = onSnapshot(q, (doc) => {
      let businessName = doc.data().businessName;
      if (businessName === "") {
        setIsBusinessNameEmpty(true);
      } else {
        setIsBusinessNameEmpty(false);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  //sideEffect for listening to user data
  useEffect(() => {
    getAuth().onAuthStateChanged((user) => {
      const q = query(doc(db, "users", user.uid));
      unsub = onSnapshot(q, (doc) => {
        let userPhone = doc.data().phoneNumber;
        let userName = doc.data().name;

        if (userName === "") {
          setIsUserNameEmplty(true);
        } else {
          setIsUserNameEmplty(false);
        }
      });
    });

    return () => {
      unsub();
    };
  }, []);

  // Update Client Info Start
  const UpdateUserInfo = async (businessName) => {
    try {
      let userDoc = await doc(db, "clients", getLocalStorageItem("bid"));
      const data = {
        businessName: businessName,
      };
      await setDoc(userDoc, data);
    } catch (error) {
    }
  };
  // Update Client Info End

  const [ListedImage, setListedImage] = useState(false);

  //   List Images Start
  const listImages = async () => {
    getAuth().onAuthStateChanged(async () => {
      listAll(ref(getStorage(), `business_logo/${getLocalStorageItem("bid")}`))
        .then(async ({ prefixes, items }) => {
          // setListedImage(
          //   items[0]._location.path_.split("/").pop().split(".").pop()
          // );
          setListedImage(
            items.length === 0 ? "" : await getDownloadURL(items[0])
          );
        })
        .catch(async () => {});
    });
  };

  useEffect(() => {
    listImages();
  }, []);
  // List Images End

  const businessID = getAuth().currentUser;

  return [AuthUser, ClientData, ListedImage];
}
